import { ca } from '@cian/analytics';

export function trackDailyrentBannerClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'dailyrent_banner',
  });
}

export function trackDailyrentBannerShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'dailyrent_banner',
  });
}
